// extracted by mini-css-extract-plugin
export var btn = "techButton-module--btn--t9tCZ";
export var text = "techButton-module--text--JTBdy";
export var only_text = "techButton-module--only_text--QyIJa";
export var img = "techButton-module--img--4lgZS";
export var hoverOverMe = "techButton-module--hoverOverMe--6z+W4";